var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[(_vm.pageContent.length)?_c('div',{staticClass:"static-wrapper",attrs:{"data-view":"","layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}},[_c('h1',[_vm._v(_vm._s(_vm.pageTitle))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.pageContent)}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-077c39ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PoliticaDePrivacidad/PoliticaDePrivacidad.vue
// module id = null
// module chunks = 